export default {"src":"/_next/static/media/WhiteAdd.bb11cd87.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};